import { render, staticRenderFns } from "./support-loader.vue?vue&type=template&id=06f74094"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f74094')) {
      api.createRecord('06f74094', component.options)
    } else {
      api.reload('06f74094', component.options)
    }
    module.hot.accept("./support-loader.vue?vue&type=template&id=06f74094", function () {
      api.rerender('06f74094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/support/components/support-loader.vue"
export default component.exports